/*============================================================================
	(c) Copyright 2014 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

	Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart

	Ajaxify the add to cart experience.

	This file includes:
		- Basic Shopify Ajax API calls
		- Ajaxify cart plugin

	This requires:
		- jQuery 1.8+
		- modernizer.min.js

	JQUERY API (c) Copyright 2009-2014 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
	Includes slight modifications to addItemFromForm.
==============================================================================*/
if ((typeof Shopify) === 'undefined') { Shopify = {}; }

/*============================================================================
	API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
	if ((typeof attribute) !== 'string') {
		attribute += '';
		if (attribute === 'undefined') {
			attribute = '';
		}
	}
	return jQuery.trim(attribute);
};

/*============================================================================
	API Functions
	- Shopify.format money is defined in option_selection.js.
		If that file is not included, it is redefined here.
==============================================================================*/
if (!Shopify.formatMoney) {
	Shopify.formatMoney = function(cents, format) {
		var value = '',
				placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
				formatString = (format || this.money_format);

		if (typeof cents == 'string') {
			cents = cents.replace('.','');
		}

		function defaultOption(opt, def) {
			return (typeof opt == 'undefined' ? def : opt);
		}

		function formatWithDelimiters(number, precision, thousands, decimal) {
			precision = defaultOption(precision, 2);
			thousands = defaultOption(thousands, ',');
			decimal   = defaultOption(decimal, '.');

			if (isNaN(number) || number == null) {
				return 0;
			}

			number = (number/100.0).toFixed(precision);

			var parts   = number.split('.'),
					dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
					cents   = parts[1] ? (decimal + parts[1]) : '';

			return dollars + cents;
		}

		switch(formatString.match(placeholderRegex)[1]) {
			case 'amount':
				value = formatWithDelimiters(cents, 2);
				break;
			case 'amount_no_decimals':
				value = formatWithDelimiters(cents, 0);
				break;
			case 'amount_with_comma_separator':
				value = formatWithDelimiters(cents, 2, '.', ',');
				break;
			case 'amount_no_decimals_with_comma_separator':
				value = formatWithDelimiters(cents, 0, '.', ',');
				break;
		}

		return formatString.replace(placeholderRegex, value);
	};
}

Shopify.onProduct = function(product) {
	// alert('Received everything we ever wanted to know about ' + product.title);
};

Shopify.onCartUpdate = function(cart) {
	// alert('There are now ' + cart.item_count + ' items in the cart.');
};

Shopify.updateCartNote = function(note, callback) {
	var params = {
		type: 'POST',
		url: '/cart/update.js',
		data: 'note=' + attributeToString(note),
		dataType: 'json',
		success: function(cart) {
			if ((typeof callback) === 'function') {
				callback(cart);
			}
			else {
				Shopify.onCartUpdate(cart);
			}
		},
		error: function(XMLHttpRequest, textStatus) {
			Shopify.onError(XMLHttpRequest, textStatus);
		}
	};
	jQuery.ajax(params);
};

Shopify.onError = function(XMLHttpRequest, textStatus) {
	var data = eval('(' + XMLHttpRequest.responseText + ')');
	if (!!data.message) {
		alert(data.message + '(' + data.status  + '): ' + data.description);
	} else {
		alert('Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.');
	}
};

/*============================================================================
	POST to cart/add.js returns the JSON of the line item associated with the added item
==============================================================================*/
Shopify.addItem = function(variant_id, quantity, callback) {
	var quantity = quantity || 1,
			params = {
		type: 'POST',
		url: '/cart/add.js',
		data: 'quantity=' + quantity + '&id=' + variant_id,
		dataType: 'json',
		success: function(line_item) {
			if ((typeof callback) === 'function') {
				callback(line_item);
			}
			else {
				Shopify.onItemAdded(line_item);
			}
		},
		error: function(XMLHttpRequest, textStatus) {
			Shopify.onError(XMLHttpRequest, textStatus);
		}
	};
	jQuery.ajax(params);
};

/*============================================================================
	POST to cart/add.js returns the JSON of the line item
		- Allow use of form element instead of id
		- Allow custom error callback
==============================================================================*/
Shopify.addItemFromForm = function(form, callback, errorCallback) {
	var params = {
		type: 'POST',
		url: '/cart/add.js',
		data: jQuery(form).serialize(),
		dataType: 'json',
		success: function(line_item) {
			if ((typeof callback) === 'function') {
				callback(line_item, form);
			}
			else {
				Shopify.onItemAdded(line_item, form);
			}
		},
		error: function(XMLHttpRequest, textStatus) {
			if ((typeof errorCallback) === 'function') {
				errorCallback(XMLHttpRequest, textStatus);
			}
			else {
				Shopify.onError(XMLHttpRequest, textStatus);
			}
		}
	};
	jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
Shopify.getCart = function(callback) {
	jQuery.getJSON('/cart.js', function (cart, textStatus) {
		if ((typeof callback) === 'function') {
			$(".shipping-savings-message-wrapper").load(" .shipping-savings-message-wrapper");
			callback(cart);
		}
		else {
			Shopify.onCartUpdate(cart);
		}
	});
};

// GET products/<product-handle>.js returns the product in JSON
Shopify.getProduct = function(handle, callback) {
	jQuery.getJSON('/products/' + handle + '.js', function (product, textStatus) {
		if ((typeof callback) === 'function') {
			callback(product);
		}
		else {
			Shopify.onProduct(product);
		}
	});
};

// POST to cart/change.js returns the cart in JSON
Shopify.changeItem = function(line, quantity, callback) {
	var params = {
		type: 'POST',
		url: '/cart/change.js',
		data:  'quantity='+quantity+'&line='+line,
		dataType: 'json',
		success: function(cart) {
			if ((typeof callback) === 'function') {
				callback(cart);
			}
			else {
				Shopify.onCartUpdate(cart);
			}
		},
		error: function(XMLHttpRequest, textStatus) {
			Shopify.onError(XMLHttpRequest, textStatus);
		}
	};
	jQuery.ajax(params);
};

Shopify.removeItem = function(line, callback) {
	var params = {
		type: 'POST',
		url: '/cart/change.js',
		data:  'quantity=0&line='+line,
		dataType: 'json',
		success: function(cart) {
			if ((typeof callback) === 'function') {
				callback(cart);
			}
			else {
				Shopify.onCartUpdate(cart);
			}
		},
		error: function(XMLHttpRequest, textStatus) {
			Shopify.onError(XMLHttpRequest, textStatus);
		}
	};
	jQuery.ajax(params);
};

/*============================================================================
	Ajaxify Shopify Add To Cart
==============================================================================*/
var ajaxifyShopify = (function(module, $) {

	'use strict';

	// Public functions
	var init;

	// Private general variables
	var settings, $nojQueryLoad, $w, $body, $html;

	// Private plugin variables
	var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $callbackData={};

	// Private functions
	var updateCountPrice, itemErrorCallback, buildCart, cartTemplate, adjustCart, adjustCartCallback, qtySelectors, validateQty;

	/*============================================================================
		Initialise the plugin and define global options
	==============================================================================*/
	init = function (options) {

		// Default settings
		settings = {
			formSelector: 'form[action^="/cart/add"]',
			addToCartSelector: 'input[type="submit"]',
			cartCountSelector  : '.cartCounter',
			cartCostSelector: null,
			useCartTemplate: true,
			moneyFormat: '$'
		};

		// Override defaults with arguments
		$.extend(settings, options);

		// Select DOM elements
		$formContainer     = $(settings.formSelector);
		$addToCart         = $formContainer.find(settings.addToCartSelector);
		$cartCountSelector = $(settings.cartCountSelector);
		$cartCostSelector  = $(settings.cartCostSelector);

		// General Selectors
		$w    = $(window);
		$body = $('body');
		$html = $('html');

		// Check if we can use .load
		$nojQueryLoad = $html.hasClass('lt-ie9');
		if ($nojQueryLoad) {
			settings.useCartTemplate = false;
		}

		// Setup ajax quantity selectors
		qtySelectors();

		$cartContainer   = $('#AjaxifyCart');

		// Run this function in case we're using the quantity selector outside of the cart
		adjustCart();
	};

	updateCountPrice = function (cart) {
		if ($cartCountSelector) {
			$cartCountSelector.html(cart.item_count).removeClass('hidden-count');

			if (cart.item_count === 0) {
				$cartCountSelector.addClass('hidden-count');
			}
		}
		if ($cartCostSelector) {
			$cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
		}
	};

	buildCart = function (cart) {
		// Empty cart if using default layout or not using the .load method to get /cart
		if (!settings.useCartTemplate || cart.item_count === 0) {
			$cartContainer.empty();
			$('.cart-page-heading').hide();
		}

		// Show empty cart
		
		if (cart.item_count === 0) {
			// $cartContainer.append('<h1>Shopping Cart</h1><p>Your cart is currently empty.</p><p><a href="/">Continue shopping &rarr;</a></p>');
			location.reload();

			return;
		}

		cartTemplate(cart);
	};

	cartTemplate = function (cart) {
		var url = '/cart?' + Date.now() + ' form[action="/cart"]';
		$cartContainer.load(url, function() {

			// With new elements we need to relink the adjust cart functions
			adjustCart();
		});
	}

	adjustCart = function () {
		// This function runs on load, and when the cart is reprinted

		// Update quantify selectors
		var qtyAdjust = $('.ajaxcart__qty-adjust');

		// Add or remove from the quantity
		qtyAdjust.off('click');
		qtyAdjust.on('click', function() {
			var el = $(this),
				line = el.closest('form').find('.cart__row').not('.is-removed').index(el.closest('.cart__row')) + 1,
				qtySelector = el.siblings('.ajaxcart__qty-num'),
				qty = parseInt(qtySelector.val().replace(/\D/g, ''), 10);

			var qty = validateQty(qty);

			// Add or subtract from the current quantity
			if (el.hasClass('ajaxcart__qty--plus')) {
				qty = qty + 1;
			} else {
				qty = qty - 1;
				if (qty <= 0) qty = 0;
			}

			// If it has a line, update the cart.
			// Otherwise, just update the input's number
			if (line) {
				updateQuantity(line, qty);
			} else {
				qtySelector.val(qty);
			}

		});

		// Update quantity based on input on change
		var qtyInput = $('.ajaxcart__qty-num');
		qtyInput.off('change');
		qtyInput.on('change', function() {
			var el = $(this),
				line = el.closest('form').find('.cart__row').not('.is-removed').index(el.closest('.cart__row')) + 1,
				qty = parseInt(el.val().replace(/\D/g, ''), 10);

			var qty = validateQty(qty);

			// Only update the cart via ajax if we have a line to work with
			if (line) {
				updateQuantity(line, qty);
			}
		});

		// Stop enter from submitting the form
		qtyInput.on('keypress', function(e) {
			if(e.which == 13) {
				var el = $(this);
				el.trigger('change');
				e.preventDefault();
			}
		});

		// Highlight the text when focused
		qtyInput.off('focus');
		qtyInput.on('focus', function() {
			var el = $(this);
			setTimeout(function() {
				el.select();
			}, 50);
		});

		// Completely remove product
		$('.ajaxcart__remove').on('click', function(e) {
			var el = $(this),
				line = el.closest('form').find('.cart__row').not('.is-removed').index(el.closest('.cart__row')) + 1;

			// Without a line, let the default link action take over
			if (!line) {
				return;
			}

			e.preventDefault();
			removeQuantity(line);
		});

		function removeQuantity(line) {
			var row = $('.cart__row').not('.is-removed').eq(line - 1).addClass('is-removed');

			// Slight delay to make sure removed animation is done
			setTimeout(function() {
				Shopify.removeItem(line, adjustCartCallback);
			}, 250);
		}

		function updateQuantity(line, qty) {
			// Add activity classes when changing cart quantities
			var row = $('.cart__row').not('.is-removed').eq(line - 1).addClass('is-loading');

			if (qty === 0) {
				row.addClass('is-removed');
			}

			// Slight delay to make sure removed animation is done
			setTimeout(function() {
				Shopify.changeItem(line, qty, adjustCartCallback);
			}, 250);
		}

		// Save note anytime it's changed
		var noteArea = $('textarea[name="note"]');
		noteArea.off('change');
		noteArea.on('change', function() {
			var newNote = $(this).val();

			// Simply updating the cart note in case they don't click update/checkout
			Shopify.updateCartNote(newNote, function(cart) {});
		});
	};

	adjustCartCallback = function (cart) {
		// Update quantity and price
		updateCountPrice(cart);

		// Reprint cart on short timeout so you don't see the content being removed
		setTimeout(function() {
			Shopify.getCart(buildCart);
		}, 150)
	};

	qtySelectors = function() {
		// Change number inputs to JS ones, similar to ajax cart but without API integration.
		// Make sure to add the existing name and id to the new input element
		var numInputs = $('.js-qty');

		if (numInputs.length) {
			// Setup listeners to add/subtract from the input
			$('.js-qty__adjust').on('click', function() {
				var el = $(this),
					qtySelector = el.siblings('.js-qty__num'),
					qty = parseInt(qtySelector.val().replace(/\D/g, ''), 10);

				var qty = validateQty(qty);

				// Add or subtract from the current quantity
				if (el.hasClass('js-qty__adjust--plus')) {
					qty = qty + 1;
				} else {
					qty = qty - 1;

					if(el.parent().hasClass('allow-0')) {
						if (qty <= 0) qty = 0;
					} else {
						if (qty <= 1) qty = 1;
					}
				}

				// Update the input's number
				qtySelector.val(qty);
			});
		}
	};

	validateQty = function (qty) {
		// Make sure we have a valid integer
		if((parseFloat(qty) == parseInt(qty, 10)) && !isNaN(qty)) {
			// We have a number!
		} else {
			// Not a number. Default to 1.
			qty = 1;
		}
		return qty;
	};

	module = {
		init: init,
		adjustCart: adjustCart
	};

	return module;

}(ajaxifyShopify || {}, jQuery));
